import { CalendarEntities } from '@app/pcs/models/calendar';
import { PathSectionsEntities } from '@dossier/models/path-section';
import { processStrategyForParent } from '@dossier/models/schema-process-strategy';
import { SubPathsEntities } from '@dossier/models/sub-path';
import {
  territoriesSchema,
  Territory,
  TerritoryEntities,
  territoryForEdit,
  territoryWarning,
  territoryWithBaseTrainParameters
} from '@dossier/models/territory';
import {gql} from 'apollo-angular';
import { schema } from 'normalizr';

export interface BaseTimetable {
  id?: number;
  dossierId?: number;
}

export interface Timetable extends BaseTimetable {
  territories: Territory[];
}

export interface TimetableEntity {
  id: number;
  territories: number[];
}

export interface TimetablesEntities {
  [key: number]: TimetableEntity;
}

export interface NormalizedTimetable {
  entities: {
    timetable: TimetablesEntities;
    territories: TerritoryEntities;
    subPaths: SubPathsEntities;
    calendar: CalendarEntities;
    pathElements: PathSectionsEntities;
  };
  result: number;
}

export const timetableSchema = new schema.Entity('timetable', {
  territories: [territoriesSchema]
}, {
  idAttribute: 'id',
  processStrategy: processStrategyForParent
});

export const timetableWithBaseTrainParameters = gql`
    fragment timetableWithBaseTrainParameters on Timetable {
        id
        territories {
            ...territoryWithBaseTrainParameters
        }
    }
    ${territoryWithBaseTrainParameters}
`;

export const timetableWarnings = gql`
    fragment timetableWarnings on Timetable {
        id
        territories {
            ...territoryWarning
        }
    }
    ${territoryWarning}
`;

export const timetableForEdit = gql`
    fragment timetableForEdit on Timetable {
        id
        territories {
            ...territoryForEdit
        }
    }
    ${territoryForEdit}
`;
